module.exports = __webpack_public_path__ + "static/media/astro_healthcare.c0eea1dd.png";